<template>
    <div>
        <h4 class="group-title">Website Badge Settings</h4>
        <p class="description">Add the eCheckpoint Verified Badge to Your Site.</p>
        <div class="groupSet card">
            <h4 class="header-title">Get a Badge</h4>
            <p>Help your customers shop with confidence.<br>
            The eCheckpoint Verified badge signals to your customers that every order they place on your site is screened for compliance with federal, state, and local laws down to the city level. That means your customers are protected. They can buy knowing they won't accidentally break the law for purchasing a regulated item.</p>
            <div>
                <div class="left">
                    <div>
                        <Label for="theme">Theme:</Label>
                        <select v-model="theme" class="form-control" id="theme" name="theme">
                            <option value="light">Light</option>
                            <option value="dark">Dark</option>
                        </select>
                    </div>
                    <div>
                        <Label for="referrer">Website:</Label>
                        <input type="text" id="referrer" name="referrer" placeholder="good.example.com" v-model="referrer" class="form-control"/>
                        
                    </div>
                </div>
                <div class="right">
                    <div>
                        <img src="..\..\..\design\assets\images\badgepreview.png">
                    </div>
                    <span class="font-12">Preview (dark theme, left, light theme, right)</span>
                </div>
            </div>
            
            <button class="btn userButton btn-primary" @click="generateBadge">Generate Badge Code</button>
            <br />
            <div v-if="script">
                <h4 class="header-title">Your Badge Code</h4>
                <p>Copy and paste the code below into your site's footer, sidebar, or product pages to display the official eCheckpoint Verified badge.</p>
                <h5>Badge Code (HTML Embed):</h5>
                <CodeSnippet :content="script" codeLang="html"></CodeSnippet>
            </div>
        </div>
    </div>
</template>

<script>
import appConfig from "@/app.config";
import { mapState, mapActions } from "vuex";
import CodeSnippet from "../CodeSnippet.vue";
export default {
    name: "BadgePage",
    page: {
        title: "badgesettings",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: {
        CodeSnippet
    },
    data() {
        return {
            theme: "",
            referrer: "",
            script: "",
        }
    },
    computed:{
        ...mapState("settings", ["Script"])
    },
    methods:
    {
        ...mapActions("settings", ["getScript"]),
        async generateBadge()
        {
            if(!this.validate())
                return;

            const host = this.extractHost(this.referrer);
            await this.getScript({theme: this.theme, referrer: host});

            this.script = this.Script;
        },
        validate()
        {
            const toCheck = ["theme", "referrer"];
            let passed = true;
            for(const prop of toCheck)
            {
                document.getElementById(prop).classList.remove("needed")
                if(!this[prop])
                {
                    document.getElementById(prop).classList.add("needed")
                    passed = false;
                }
            }
            return passed;
        },
        extractHost(input)
        {
            // try URL
            try 
            {
                if (/^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(input)) 
                {
                    const url = new URL(input);
                    return this.normalizeHost(url.host, url.protocol)?.toLowerCase();
                }
            }
            catch (e) {/**/}

            //fallback
            const stripped = input.replace(/^\/\//, '');
            const match = stripped.match(/^([^/]+)(?:\/|$)/);
            if (match)
                return this.normalizeHost(match[1], "http:")?.toLowerCase();

            return null;
        },
        normalizeHost(host, protocol) 
        {
            const [hostname, port] = host.toLowerCase().split(":");
            if ((protocol === "http:" && port === "80") || (protocol === "https:" && port === "443")) 
                return hostname;
            return port ? hostname + ":" + port : hostname;
        }
    },
    
}
</script>

<style lang="scss" scoped>
.form-control
{
    width: 24em;
    display: inline-block;
    margin-bottom: 0.5em;
}

label
{
    width: 10em;
    vertical-align: middle;
    font-weight: 600;
    margin: 0;
}

button
{
    margin-right: auto;
    width: auto;
}

.needed 
{
    outline: 4px solid #FF6666;
}

.userButton
{
    margin-top: .5em;
    margin-bottom: 1em;
}

.left {
    width: 50%;
    float: left;
}

.card
{
    z-index: 1;
}

.right {
    height: 100%;
    width: fit-content;
    max-width: 50%;
    float: left;
    text-align: center;

    > img 
    {
        width: 320px;
    }

    > div 
    {
        padding: 1em 1em 1em 1em;
        border: 1px solid #ddd;
        border-radius: 1em;
        width: fit-content;
        background: linear-gradient(121deg, black 49.85%, white 50.15%);
    }
}

</style>